import { type FC } from 'react'
import { render } from 'storyblok-rich-text-react-renderer'
// import { Teaser } from '~/components/Teaser/Teaser'
import classNames from 'classnames'
import { type TableStoryblok } from '~/types/generated'
import { Table } from '../Table/Table'
import { type RichTextProps } from './RichText.interface'
import styles from './RichText.module.scss'
// import { withSbMapping } from '~/withSbMapping'
// import { mapTeaser } from '~/components/Teaser/Teaser.mapping'

const resolverMap = {
  // teaser: withSbMapping(Teaser, mapTeaser)
  // eslint-disable-next-line react/jsx-props-no-spreading
  table: (props: TableStoryblok) => <Table {...props} />
}

export const RichText: FC<RichTextProps> = ({ richtext, className }) => {
  const options: Record<string, unknown> = {
    blokResolvers: resolverMap
  }
  return (
    <div className={classNames(styles.richtext, className)}>
      {render(
        richtext,
        options
      )}
    </div>
  )
}
